export default ({ COLORS }) => ({
  link: {
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none',
    fontWeight: 'bold'
  },
  date: {
    whiteSpace: 'nowrap'
  },
  checkboxChell: {
    borderLeft: `5px solid transparent`
  },
  center: {
    textAlign: 'center'
  },
  right: {
    textAlign: 'right'
  },
  thumbnail: {
    padding: '10px',
    '& > a': {
      display: 'block',
      position: 'relative',
      background: '#ececec',
      border: '1px solid #ececec',
      width: '100%',
      paddingBottom: '133%',
      borderRadius: '8px',
      overflow: 'hidden',
      '& > span': {
        position: 'absolute',
        left: '0',
        top: '0',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%'
      }
    }
  }
})
